import { writable } from 'svelte/store';
import { AssetService } from '../../services';
const assetService = new AssetService();
const { set, update, subscribe } = writable({
    assets: [],
    loading: false
});
const actions = {
    fetchAssets: () => update(store => {
        assetService.fetchAll().then(assets => {
            update(store => ({ ...store, assets, loading: false }));
        });
        return { ...store, loading: true };
    })
};
export default {
    ...actions,
    subscribe
};
